<script lang="ts">
	import { env } from "$lib/env.client";
	import { onMount } from "svelte";

	onMount(() => {
		//  Wrap in try catch because Bing sucks and their shit explodes (see sentry SMORE-FRONTEND-5ZE)
		try {
			(function (w, d, t, r, u) {
				var f, n, i;
				(w[u] = w[u] || []),
					(f = function () {
						var o = { ti: "137027127" };
						(o.q = w[u]), w.UET ? (w[u] = new w.UET(o)) : "", w[u].push("pageLoad");
					}),
					(n = d.createElement(t)),
					(n.src = r),
					(n.async = 1),
					(n.onload = n.onreadystatechange =
						function () {
							var s = this.readyState;
							(s && s !== "loaded" && s !== "complete") || (f(), (n.onload = n.onreadystatechange = null));
						}),
					(i = d.getElementsByTagName(t)[0]),
					i.parentNode.insertBefore(n, i);
			})(window, document, "script", "//bat.bing.com/bat.js", env.PUBLIC_BING_PIXEL_ID);
		} catch (e) {
			// do nothing
		}
	});
</script>
